<template>
  <div class="size-split-variant-wrapper">
    <SizeSelection
      v-model="selectedSizeId"
      v-model:touched="touched"
      v-bind="sizeProps"
      :product-id="id"
      :name="`cta-sizes-${id}`"
      :is-size-chart="isSizeChartTopLevel"
      :is-spacing-enabled="isSpacingExperimentEnabled"
      :size-chart-img="sizeChartImageTopLevel"
      :size-chart-id="sizeChartIdTopLevel"
      :brand-name="brandName"
      :type-name="typeName"
      :experiment-flags="experimentFlagsObj"
      :class="isSpacingExperimentEnabled ? 'margin-bottom-xs' : 'margin-bottom-m'"
      :label="sizeLabel"
    />

    <ProductType
      v-if="types.length"
      :id="id"
      v-model="selectedTypeId"
      :types="types"
      :is-spacing-enabled="isSpacingExperimentEnabled"
      :label="typeLabel"
      :class="isSpacingExperimentEnabled ? 'margin-bottom-s' : 'margin-bottom-m'"
    />
  </div>
</template>

<script setup>
/* istanbul ignore file */
import { useStore } from 'vuex';
import { ref, computed, watch } from 'vue';
import { useUpc } from '@common-vue/media-card-large';
import { SizeSelection } from '@common-vue/media-card-large/src/modules/size';
import { useTraitAnalyticsData } from '@common-vue/media-card-large/src/composables/useTraitAnalyticsData';
import { ProductType } from '@common-vue/media-card-large/src/modules/type';
import { useType } from '@modules/types';
import { useBrand } from '@composables/useBrand';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { useExperiments } from '@composables/useExperiments';
import { useSize } from '@modules/size/composables';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  product: {
    /** @type import('vue').PropType<Product> */
    type: Object,
    required: true
    ,
  },
  productPricingState: {
    type: Array,
    required: true,
  },
});

const { isMcom } = useBrand();
const { brandName, typeName } = useCommonProductGetters({ id: props.id });
const { label: sizeLabel, sizeProps, selectedSizeId } = useSize(props.id, props.product);
const { selectedUpcId } = useUpc(props.id);
const {
  experimentFlags: { isSpacingExperimentEnabled },
} = useExperiments();

const experimentFlagsObj = {
  isSpacingExperimentEnabled,
};

const store = useStore();
const availabilityData = computed(() => store.state.availabilityStore.data);

const touched = ref(false);

const sizeChartIdTopLevel = props.product.traits.sizes?.sizeChartId || '';
const sizeChartImageTopLevel = props.product.traits.sizes?.sizeChartImg || '';
const isSizeChartTopLevel = computed(() => ((!!sizeChartIdTopLevel || !!sizeChartImageTopLevel) && !!sizeProps?.value.sizes.length));

const { fireTagOnChange } = useTraitAnalyticsData({
  isConsolidatedMaster: false,
  isMcom,
  product: props.product,
  isSplitThirdVariant: true,
});

const { types, label: typeLabel, selectedTypeId } = useType(props.id);

watch(selectedTypeId, () => {
  const selectedSddData = availabilityData.value?.upcNumberSddMap || {};

  fireTagOnChange({
    selectedUpcId: selectedUpcId.value,
    isVariant: true,
    productPricingState: props.productPricingState,
    selectedSddData,
  });
});
</script>
